<template>
  <div class="date-picker d-flex align-center">
    <v-menu
      v-model="isShow"
      transition="scale-transition"
      :close-on-content-click="false"
      offset-y min-width="0"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="dateRangeText"
          v-bind="attrs" v-on="on"
          append-icon="calendar_today"
          outlined dense readonly hide-details
          class="dateAlign" background-color="white"
          @click:append="isShow = !isShow"
          :disabled="disabled"
        />
      </template>
      <v-date-picker
        v-model="dates" locale="ko-kr" range
        @input="closeTwoClick"
        :show-current="false"
        :day-format="removeBackWord"
        :disabled="disabled"
      />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: ["startDate", "endDate", "disabled"],
  data() {
    return {
      isShow: false,
      isSecondClick: false,
      dates: ['', ''],
      backupDates: ['', '']
    }
  },
  computed: {
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
  },
  created() {
    this.dates = [this.startDate, this.endDate];
  },
  methods: {
    validation() {
      if (this.isSecondClick) {
        this.$emit('updateDate', [this.dates[0], '']);
      } else {
        const s = this.dates[0].split('-');
        const e = this.dates[1].split('-');

        const diffDay = (new Date(e[0], e[1], e[2]) - new Date(s[0], s[1], s[2])) / 1000 / 60 / 60 / 24;

        if (diffDay < 0) {
          let temp = this.dates[0]
          this.dates[0] = this.dates[1];
          this.dates[1] = temp;
          this.validation();
        } else {
          if (diffDay > 365) {
            alert("일자 범위는 1년 이내로 설정해주세요.");
            this.dates[1] = '';
            this.$emit('updateDate', [this.dates[0], this.dates[1]]);
          } else {
            this.$emit('updateDate', [this.dates[0], this.dates[1]])
          }
        }
      }
    },
    removeBackWord(d) {
      return new Date(d).getDate();
    },
    closeTwoClick() {
      if (this.isSecondClick) {
        this.isSecondClick = false;
        this.isShow = false;
      } else {
        this.isSecondClick = true;
      }
      this.validation();
    }
  }
}
</script>

<style>
.date-picker {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  flex: 1 1 auto;
}
.dateAlign {
  font-size: min(3vw, 16px);
}
</style>